'use client';

import { useState, useEffect, FC } from 'react';
import { fetchRemoteConfig } from '@/hotdesk-ui/common-classes/firebase.service';
import { useAppDispatch } from '@/hotdesk-ui/hooks/hook';
import { RemoteConfigKeys } from '@/hotdesk-ui/enum/remote-keys';
import { setIsOpen } from '@/hotdesk-ui/store/slices/popup.slice';
import Banner from './Banner';
interface BannerClientWrapperProps {
  languageCode: string;
  handleCloseBanner: () => void;
}
const BannerClientWrapper: FC<BannerClientWrapperProps> = ({
  languageCode,
  handleCloseBanner
}) => {
  const [appCta, setAppCTA] = useState('');
  const dispatch = useAppDispatch();
  function appQRCode() {
    if (window.innerWidth > 992) {
      dispatch(setIsOpen(true));
    } else {
      window.location.href = appCta;
    }
  }
  const getRemoteConfig = async () => {
    try {
      const appCtaData = await fetchRemoteConfig(RemoteConfigKeys.QR_LINK, 'object');
      setAppCTA(appCtaData as string);
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    getRemoteConfig();
  }, [languageCode]);
  return <Banner onCtaClick={appQRCode} handleCloseBanner={handleCloseBanner} data-sentry-element="Banner" data-sentry-component="BannerClientWrapper" data-sentry-source-file="BannerClientWrapper.tsx" />;
};
export default BannerClientWrapper;